import ArrowLeft from 'assets/icons/arrow-left.svg';
import { useRouteContext } from 'contexts/route';
import useIsClient from 'hooks/common/use-is-client';
import { useRouter } from 'next/router';
import React from 'react';

const BackButton: React.FC = () => {
  const { previousPath } = useRouteContext();
  const { back, asPath } = useRouter();
  const { isClient } = useIsClient();

  if (isClient && previousPath !== null && previousPath !== asPath) {
    return (
      <button
        data-variant="with-back-button"
        onClick={(e) => {
          e.preventDefault();
          back();
        }}
        className="hidden"
      >
        <ArrowLeft className="h-10 w-10" />
      </button>
    );
  }

  return null;
};

export default BackButton;
